export const INFO_BOX_TYPES = {
  DEFAULT: 'default',
  DATA_POINT: 'dataPoint',
  PERFORMANCE_ITEM: 'performanceItem'
};
